import(/* webpackMode: "eager" */ "/vercel/path0/apps/shopify/src/app/page.tsx");
